import { resolveMediaUrl } from '@/utils/media';
import type { PortfolioStory } from '@/types/domain';
import styles from './ProfileFeed.module.css';

export interface PortfolioPostCardProps {
  story: PortfolioStory;
  onOpen: () => void;
}

export function PortfolioPostCard({
  story,
  onOpen,
}: PortfolioPostCardProps): JSX.Element {
  return (
    <article className={styles.card}>
      <button
        type="button"
        className={styles.postImageButton}
        onClick={onOpen}
        aria-label={story.caption || 'Відкрити фото'}
      >
        <img
          src={resolveMediaUrl(story.image_url)}
          alt={story.caption || ''}
          className={styles.postImage}
          loading="lazy"
        />
      </button>
      {story.caption ? <p className={styles.postCaption}>{story.caption}</p> : null}
    </article>
  );
}
